import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListEntityPicker } from '@work4all/components/lib/components/entity-picker/components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from '@work4all/components/lib/components/entity-picker/types';

import { EMailPriority } from '@work4all/models/lib/Enums/EMailPriority.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const EmailPrioTranslationKeys: Record<string, string> = {
  NORMAL: 'COMMON.NORMAL',
  LOW: 'COMMON.LOW',
  HIGH: 'COMMON.HIGH',
};

export type IEmailPrioPickerProps<TMultiple extends boolean> = IPickerProps<
  { id: EMailPriority; name: string },
  TMultiple
>;

export function EmailPrioPicker<TMultiple extends boolean>(
  props: IEmailPrioPickerProps<TMultiple>
) {
  const { ...rest } = props;

  const { t } = useTranslation();

  const dataSet = useMemo(() => {
    const taskStatusValues: { id: string; name: string }[] = [
      {
        id: 'NORMAL',
        name: t(EmailPrioTranslationKeys['NORMAL']),
      },
      {
        id: 'LOW',
        name: t(EmailPrioTranslationKeys['LOW']),
      },
      {
        id: 'HIGH',
        name: t(EmailPrioTranslationKeys['HIGH']),
      },
    ];

    return {
      total: taskStatusValues.length,
      loading: false,
      fetchMore: () => Promise.resolve(),
      refetch: () => Promise.resolve(null),
      data: taskStatusValues,
    };
  }, [t]);

  return (
    <ListEntityPicker
      entity={Entities.eMail}
      multiple={false}
      maxItems={Math.max(dataSet.total, 3)}
      data={EMAIL_PRIO_FIELDS}
      filterBy="name"
      sortBy="name"
      clearable={false}
      {...rest}
      fixedDataSet={dataSet}
      renderItemContent={(status) => (
        <Typography variant="body2" noWrap>
          {status.name}
        </Typography>
      )}
    />
  );
}

const EMAIL_PRIO_FIELDS = {
  id: null,
  name: null,
};
